// @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'Event'. Did you mean to use 'import Event from "src/api-parsers/events"' instead? | TS2614 - Module '"src/api-parsers/events"' has no exported member 'SendMetadataSuppressionKeys'. Did you mean to use 'import SendMetadataSuppressionKeys from "src/api-parsers/events"' instead?
import type {Event, SendMetadataSuppressionKeys} from 'src/api-parsers/events';
import type {
  SenseEvent,
  EventTemplate,
  EventAttachment,
} from 'src/types/events';

import Store from './base';
import findKey from 'lodash/findKey';


export type EventError = {
  errors: string[];
  status: number;
  message?: string;
};

export type EventTypeEnumType = {
  Message: 'message';
  Survey: 'survey';
  SMS_Message: 'sms_message';
  SMS_Survey: 'sms_survey';
  SMS_Chatbot: 'sms_chatbot';
  SMS_Job: 'sms_job'; //SM-57;
  NPS: 'nps'; // exists on client side but not in DB;
  SMS_NPS: 'sms_nps'; // exists on client side but not in DB;
  List: 'digest_email';
  BeeFree_Email: 'beefree_email';
  BeeFree_Chatbot: 'beefree_chatbot';
  Bulk_Writeback: 'bulk_writeback';
};

export const EventTypeEnum: EventTypeEnumType = {
  Message: 'message',
  Survey: 'survey',
  SMS_Message: 'sms_message',
  SMS_Survey: 'sms_survey',
  SMS_Chatbot: 'sms_chatbot',
  SMS_Job: 'sms_job', //SM-57
  NPS: 'nps', // exists on client side but not in DB
  SMS_NPS: 'sms_nps', // exists on client side but not in DB
  List: 'digest_email',
  BeeFree_Email: 'beefree_email',
  BeeFree_Chatbot: 'beefree_chatbot',
  Bulk_Writeback: 'bulk_writeback',
};

export default class EventStore extends Store {
  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Store'.
  state: {
    editing: boolean;
    events: Partial<Record<string | number, SenseEvent>>;
    eventTemplates: Partial<Record<string | number, EventTemplate>>;
    saving: boolean;
    deleted: Partial<Record<string | number, SenseEvent>>;
    error?: EventError;
  };

  constructor() {
    super('events');

    this.state = {
      editing: false,
      events: {},
      eventTemplates: {},
      saving: false,
      deleted: {},
    };
  }

  getEvent(eventId: string): Event {
    return this.state.events[eventId];
  }

  getEditEvent(): Event | null | undefined {
    return this.state.events['editing'];
  }

  getSuppressionValue({
    sendMetadata,
  }: Event): SendMetadataSuppressionKeys | null | undefined {
    let suppressionValue;

    if (sendMetadata) {
      suppressionValue = findKey(sendMetadata);
    }

    return suppressionValue;
  }

  getTemplate(eventId: string): EventTemplate {
    // @ts-expect-error - TS2322 - Type 'EventTemplate | undefined' is not assignable to type 'EventTemplate'.
    return this.state.eventTemplates[eventId];
  }

  receive(event: Event) {
    this.updateState({
      events: {
        [event.id]: {
          $set: event,
        },
      },
    });
  }

  receiveTemplate(eventId: string, template: EventTemplate) {
    this.updateState({
      eventTemplates: {
        [eventId]: {
          $set: template,
        },
      },
    });
  }

  receiveAttachments(eventId: string, attachments: EventAttachment[]) {
    if (this.state.events[eventId]) {
      this.updateState({
        events: {
          [eventId]: {
            attachments: {
              $set: attachments,
            },
          },
        },
      });
    }
  }

  setEvent(event: Event) {
    this.updateState({
      events: {
        [event.id]: {
          $set: event,
        },
      },
    });
  }

  setTemplate(eventId: string, template: EventTemplate) {
    this.updateState({
      eventTemplates: {
        [eventId]: {
          $set: template,
        },
      },
    });
  }

  // @ts-expect-error - TS7030 - Not all code paths return a value.
  isEditing(editing: boolean): boolean | null | undefined {
    if (!arguments.length) {
      return this.state.editing;
    } else {
      this.setState({editing});
    }
  }

  setDeleted(event: SenseEvent) {
    this.setState({deleted: {...this.state.deleted, [event.id]: event}});
  }

  getDeleted(eventId: string | number): SenseEvent {
    // @ts-expect-error - TS2322 - Type 'SenseEvent | undefined' is not assignable to type 'SenseEvent'.
    return this.state.deleted[eventId];
  }

  setError(error: Error) {
    this.updateState({
      error: {
        $set: error,
      },
    });
  }

  getError(): EventError | null | undefined {
    return this.state.error;
  }

  clearError() {
    this.updateState({
      error: {
        $set: undefined,
      },
    });
  }
}
